import ManifestoSection from "@/components/ManifestoSection";
import ConcentrationSection from "@/components/ConcentrationSection";
import MaturationSection from "@/components/MaturationSection";
import PerformanceStats from "@/components/PerformanceStats";
import EditorialMarquee from "@/components/EditorialMarquee";
import Seo from "@/components/Seo";

export default function Experience() {
  return (
    <main data-testid="experience-page" className="pt-16 md:pt-20">
      <Seo
        title="The Reserve 30 Experience — Reserve 30 Parfums"
        description="Composed, matured 8–10 weeks and worn as a mark. Parfum concentration, patience and performance — the Reserve 30 Experience."
      />
      <ManifestoSection />
      <ConcentrationSection />
      <EditorialMarquee />
      <MaturationSection />
      <PerformanceStats />
    </main>
  );
}
